export const APP_ENV = process.env.REACT_APP_ENV;
export const APP_VERSION = process.env.REACT_APP_VERSION;
